<template>
    <div id="nav" :class="navStyle" class="hi">
        <div class="nav-container">
            <!-- Logo -->
            <img class="logo" src="../assets/img/logo_white.png">

            <!-- Pages Menu -->
            <transition tag="div" name="pages-menu">
                <PagesMenu class="menu" v-show="isMenu('pages')"/>
            </transition>

            <!-- Sections Menu -->
            <transition tag="div" name="sections-menu">
                <SectionsMenu class="menu" v-show="isMenu('sections')"/>
            </transition>

            <!-- Display Button (HomeNav <-> PageNav) -->
            <div class="menu-btn" v-show="!isHomeTopNav()" @click="setCurrMenu('switch')">
                <transition-group tag="div" name="menu-btn">
                    <i class="fas" :class="'fa-angle-down'" v-show="isMenu('pages')" :key="'down'"></i>
                    <i class="fas" :class="'fa-angle-left'" v-show="isMenu('sections')" :key="'left'"></i>
                </transition-group>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMenu from './menu/PagesMenu.vue'
import SectionsMenu from './menu/SectionsMenu.vue'

export default {
    name:'Nav',
    components:{PagesMenu, SectionsMenu},
    data() {
        return {
            navStyle: '',    // current nav style (regular-nav / home-top-nav)
            currMenu: 'pages',    // current menu (pages / sections)
        }
    },
    methods: {
        // Set navStyle to regular-nav / home-top-nav
        setNavStyle(){
            if(this.$router.currentRoute.name === 'Home' && window.top.scrollY < 100){
                this.navStyle = 'home-top-nav'
            }else{
                this.navStyle = 'regular-nav'
            }
        },
        // Is the current nav style be 'home-top-nav'?
        isHomeTopNav(){
            return this.navStyle === 'home-top-nav'
        },
        // Set currMenu
        setCurrMenu(menuType){
            // if param is 'switch', then switch the currMenu
            if(menuType === 'switch'){
                this.currMenu = this.currMenu === 'pages' ? 'sections' : 'pages'
            }else{
                this.currMenu = menuType
            }
        },
        // Is the currMenu equals to the param?
        isMenu(menuType){
            return this.currMenu === menuType
        },
        onScroll(){
            if(window.top.scrollY < 100){
                this.setCurrMenu('pages')
            }else{
                this.setCurrMenu('sections')
            }
            this.setNavStyle()
        },
    },
    watch:{
        $route(){
            // When the router is switched, reset the navStyle and currMenu
            this.setNavStyle()
            this.setCurrMenu('pages')
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.setNavStyle()
        })
        window.addEventListener('scroll', this.onScroll)
    },
}
</script>

<style scoped>
/* Nav Styles */
/* common nav styles */
#nav{
    line-height: 50px;
    text-align: center;
    z-index: 9999;

}
/* regular nav styles */
.regular-nav{
    height: 50px;
    position: sticky;
    float: left;
    top: 0;
    left: 0;
    color: #fff;
    background-color: #181e2def;
    transition: height 0.5s;
}
/* home-top nav styles (color becomes transparent) */
.home-top-nav{
    height: 50px;
    position: relative;
    margin-bottom: -50px;
    background-color: transparent;
}
/* nav container styles (contain the logo and menus) */
.nav-container{
    display: inline-block;
    position: relative;
    height: 50px;
    width: 900px;
}


/* Logo Styles */
.logo{
    display: inline-block;
    position: absolute;
    margin-top: 15px;
    left: 0;
    height: 20px;
    background: no-repeat contain;
}


/* Menu Styles */
/* menu position */
.menu{
    position: absolute;
    right: 60px;
    height: 50px;
}
/* Pages Menu leaves and appears animations */
.pages-menu-enter-active{
    animation: pages-menu-fade 0.5s ease-in;
}
.pages-menu-leave-active{
    animation: pages-menu-fade 0.5s ease-in reverse;
}
@keyframes pages-menu-fade{
    from{
        transform: translateY(-20px);
        opacity: 0;
    }
    to{
        transform: translateX(0);
        opacity: 1;
    }
}
/* Sections Menu leaves and appears animations */
.sections-menu-enter-active{
    animation: sections-menu-fade 0.5s ease-in;
}
.sections-menu-leave-active{
    animation: sections-menu-fade 0.5s ease-in reverse;
}
@keyframes sections-menu-fade{
    from{
        transform: translateX(100px);
        opacity: 0;
    }
    to{
        transform: translateX(0);
        opacity: 1;
    }
}


/* Menu Button Styles */
.menu-btn{
    display: inline-block;
    height: 50px;
    width: 50px;
    font-size: 25px;
    line-height: 50px;
    color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    position: absolute;
    right: 10px;
}
.menu-btn:hover{
    background-color: rgba(199, 199, 199, 0.265);
    color: rgba(255, 255, 255);
}
.menu-btn i{
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    height: 50px;
    line-height: 50px;
}
/* Menu Button switching animations */
.menu-btn-enter-active{
    animation: menu-btn-fade 0.2s;
}
.menu-btn-leave-active{
    animation: menu-btn-fade 0.2s reverse;
}
@keyframes menu-btn-fade{
    from{
        opacity: 0;
    }
    to{
        opacity: 1;
    }
}
</style>